<template>
  <div class="pdt-0">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('dispositifPublicitaire.titleInOnglet.info') }}
        </p>
      </header>
      <div class="card-content columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('dispositifPublicitaire.planRecollement')">
            <b-input v-model="dispositifTechnique.planRecollement"></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('dispositifPublicitaire.particularite')">
            <b-input v-model="dispositifTechnique.particularite"></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('dispositifPublicitaire.cableEdfProx')">
            <qd-checkbox v-model="dispositifTechnique.cableEdfProx">
            </qd-checkbox>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field
            :label="$t('dispositifPublicitaire.distanceEnMCablesEdf')" >
            <input-currency v-model="dispositifTechnique.distanceEnMCablesEdf"
                            isNumber="true">
            </input-currency>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('dispositifPublicitaire.fournisseurElectricite')">
            <b-autocomplete
              :value="libelleFournisseur"
              :open-on-focus="false"
              :data="fournisseurs"
              field="nomCommercial"
              :placeholder="$i18n.t('general.autocomplete.search')"
              @input="getFournisseur"
              :loading="isFetchingFournisseur"
              @select="setFournisseur">
              <template slot="empty">
                <div v-if="!isFetchingFournisseur">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
                <div v-else>
                  {{$t('general.autocomplete.search')}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('dispositifPublicitaire.proprietaire')">
            <b-autocomplete
              :value="libelleTiers"
              :open-on-focus="false"
              :data="tiers"
              field="nomCommercial"
              :placeholder="$i18n.t('general.autocomplete.search')"
              @input="getTiers"
              :loading="isFetchingTiers"
              @select="setTiers">
              <template slot="empty">
                <div v-if="!isFetchingTiers">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
                <div v-else>
                  {{$t('general.autocomplete.search')}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field
            :label="$t('dispositifPublicitaire.longueur')" >
            <input-currency v-model="dispositifTechnique.longueur"
                            isNumber="true">
            </input-currency>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field
            :label="$t('dispositifPublicitaire.largeurToit')" >
            <input-currency v-model="dispositifTechnique.largeurToit"
                            isNumber="true">
            </input-currency>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field
            :label="$t('dispositifPublicitaire.hauteurSousPanneau')" >
            <input-currency v-model="dispositifTechnique.hauteurSousPanneau"
                            isNumber="true">
            </input-currency>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('dispositifPublicitaire.nacelleNecessaire')">
            <qd-checkbox v-model="dispositifTechnique.nacelleNecessaire">
            </qd-checkbox>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('dispositifPublicitaire.echelleNecessaire')">
            <qd-checkbox v-model="dispositifTechnique.echelleNecessaire">
            </qd-checkbox>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('dispositifPublicitaire.grueNecessaire')">
            <qd-checkbox v-model="dispositifTechnique.grueNecessaire">
            </qd-checkbox>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('dispositifPublicitaire.autreEquipementNecessaire')">
            <b-input v-model="dispositifTechnique.autreEquipementNecessaire"></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('dispositifPublicitaire.obstacle')">
            <b-input v-model="dispositifTechnique.obstacle"></b-input>
          </b-field>
        </div>
      </div>
    </div>
    <div class="card mgt-30px">
      <header class="header-card">
        <p>
          {{ $t('dispositifPublicitaire.titleInOnglet.accessoire') }}
        </p>
      </header>
      <div class="card-content columns is-multiline">
        <b-table :data="dispositifAccessoires" :bordered="true" :striped="true"
                 class="column is-6">
          <b-table-column
            header-class="has-text-default"
            field="libelle"
            v-slot="props"
            :label="$t('dispositifPublicitaire.dispositifAccessoires.champs.accessoire')">
            <parametre-autocomplete
              v-model="props.row.accessoireId"
              :target="constantes.PARAMETRES_KEYS.accessoire"
              :custom-map-item="(item) => ({
                ...item,
                libelleComplet: [
                  item.libelle,
                  item.fournisseur ? item.fournisseur.nomCommercial : '',
                ].filter(Boolean).join(' - '),
              })"
              field="libelleComplet"
              expanded
            />
          </b-table-column>
          <b-table-column
            header-class="has-text-default"
            field="quantite"
            v-slot="props"
            :label="$t('dispositifPublicitaire.dispositifAccessoires.champs.quantite')">
            <b-input v-model="props.row.quantite" type="number"></b-input>
          </b-table-column>
          <b-table-column v-slot="props">
            <div class="has-text-centered mgt-5px is-cursor-pointer"
                 @click="deleteAccessoire(props.index)">
              <b-icon type="is-danger"
                      icon="delete-forever">
              </b-icon>
            </div>
          </b-table-column>
          <template #empty>
            {{ $t('general.autocomplete.noRslt')}}
          </template>
          <template #footer>
            <div class="has-text-right">
              <button
                class="button is-primary"
                @click="addAccessoire()">
                {{ $t('dispositifPublicitaire.dispositifAccessoires.action.add') }}
              </button>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import inputCurrency from '@/components/general/inputCurrency';
import messageErreur from '@/services/general/messageErreur';
import { TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';
import { getAll } from '@/api/tiers/index';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import genererDispositifAccessoires from '@/services/gabed/dispositif/genererDispositifAccessoires';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'm_infoTechnique',
  props: {
    dispositifPublicitaire: {
      type: Object,
      required: true,
    },
    dispositifTechnique: {
      type: Object,
      required: true,
    },
    dispositifAccessoires: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fournisseurs: [],
      libelleFournisseur: null,
      isFetchingFournisseur: false,
      tiers: [],
      libelleTiers: null,
      isFetchingTiers: false,
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  components: {
    ParametreAutocomplete,
    inputCurrency,
  },
  methods: {
    deleteAccessoire(index) {
      this.dispositifAccessoires.splice(index, 1);
    },
    addAccessoire() {
      this.dispositifAccessoires.push(cloneDeep(genererDispositifAccessoires()));
    },
    getFournisseur: debounce(async function fournisseurData(text) {
      if (text === this.libelleFournisseur) return;
      try {
        this.libelleFournisseur = text;
        this.dispositifTechnique.fournisseurElectriciteId = null;
        this.isFetchingFournisseur = true;
        this.fournisseurs = (await getAll(
          {
            query: {
              nomCommercial: text,
              type: TIERS_TYPE_FOURNISSEUR,
              societeId: this.societeActiveId,
              archive: false,
            },
            limit: NO_PAGINATION,
          },
        )).data.result.items;
        this.isFetchingFournisseur = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingFournisseur = false;
        throw e;
      }
    }),
    setFournisseur(newFournisseur) {
      if (!newFournisseur) return;
      this.libelleFournisseur = newFournisseur.nomCommercial;
      this.dispositifTechnique.fournisseurElectriciteId = newFournisseur.id;
    },
    getTiers: debounce(async function TiersData(text) {
      if (text === this.libelleTiers) return;
      try {
        this.libelleTiers = text;
        this.dispositifTechnique.tiersProprietaireId = null;
        this.isFetchingTiers = true;
        this.tiers = (await getAll({
          query: {
            auto: text,
            societeId: this.societeActiveId,
          },
          limit: NO_PAGINATION,
        })).data.result.items;
        this.isFetchingTiers = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingTiers = false;
        throw e;
      }
    }),
    setTiers(newTiers) {
      if (!newTiers) return;
      this.libelleTiers = newTiers.nomCommercial;
      this.dispositifTechnique.tiersProprietaireId = newTiers.id;
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  mounted() {
    if (this.$route.params.idDispositif) {
      this.setInformationPage(this.$t('pageGeneral.modification', { item: this.dispositifPublicitaire.code }));
      this.libelleFournisseur = this.dispositifTechnique.fournisseurElectricite
        ? this.dispositifTechnique.fournisseurElectricite.nomCommercial : null;
      this.libelleTiers = this.dispositifTechnique.tiersProprietaire
        ? this.dispositifTechnique.tiersProprietaire.nomCommercial : null;
    }
  },
};
</script>
